module.exports = __webpack_public_path__ + "static/img/c6.0623c40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/c6.png
// module id = U6Js
// module chunks = 0